import { Component, EventEmitter, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'dp-internal-server-error',
    templateUrl: './internal-server-error.component.html',
    imports: [MatButton],
})
export class InternalServerErrorComponent {
  @Output() onReloadClick = new EventEmitter();
}
